import { Box } from '@mui/material'
import { CarrierType, OperationalEquipmentDto } from '@operations/app/api'
import { DescriptionContainer } from '@operations/features/equipmentOperator/components/JobCard/DescriptionContainer'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, Tile } from '@tom-ui/ui'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'

interface Props {
  operationalEquipments: OperationalEquipmentDto[]
}
export const OperationalEquipmentSelectionDetails = observer(({ operationalEquipments }: Props) => {
  const { t } = useTranslate()

  const assignedCarriers = computed(() => {
    return operationalEquipments
      .flatMap(x => x.assignments)
      .reduce((acc, assignment) => {
        const type = assignment?.carrierVisit?.type
        if (type && !acc.includes(type)) {
          acc.push(type)
        }

        return acc
      }, [] as CarrierType[])
  }).get()

  const assignedBlocks = computed(() => {
    const blockList = operationalEquipments
      .flatMap(x => x.assignments)
      .reduce((acc, assignment) => {
        const name = assignment?.yardBlock?.name
        if (name && !acc.includes(name)) {
          acc.push(name)
        }

        return acc
      }, [] as string[])

    return blockList.length > 0 ? blockList.join(', ') : t('notAssigned', 'Not assigned')
  }).get()

  return (
    <DescriptionContainer>
      <Tile label={t('quantity', 'Quantity')} value={operationalEquipments.length} />
      <Tile
        label={t('equipmentType', 'Equipment type')}
        value={operationalEquipments[0]?.equipmentType ?? EmptyIndicator}
      />
      <Tile
        label={t('assignedCarrier', 'Assigned carrier')}
        value={assignedCarriers.map(x => t(x)).join(', ')}
      />
      <Box width='100px'>
        <Tile
          label={t('assignedArea', 'Assigned area')}
          value={assignedBlocks}
          showElipsis
          nowrap
          displayTooltip
        />
      </Box>
    </DescriptionContainer>
  )
})
